module.exports = __webpack_public_path__ + "img/placeholder.b6cdf69e.png";